import { createCommand, LexicalCommand } from 'lexical';

import { HighlightColor } from './highlightConstants';

/** Apply a highlight color to the current selection. If the selection is
 *  already highlighted with the same color, the highlight is removed (toggle). */
export const APPLY_HIGHLIGHT_COMMAND: LexicalCommand<HighlightColor> =
  createCommand('APPLY_HIGHLIGHT_COMMAND');

/** Remove any highlight from the current selection. */
export const REMOVE_HIGHLIGHT_COMMAND: LexicalCommand<void> = createCommand(
  'REMOVE_HIGHLIGHT_COMMAND'
);
